import React from 'react';
import ReactDOM from 'react-dom/client';
import posthog from 'posthog-js';
import './App.css';
import App from './App';

posthog.init('phc_paaZZmfNWTZpdsaL2AAFeZDzvtnS9oiP6n7EZ8Yxan5W', {
  api_host: 'https://us.i.posthog.com',
  person_profiles: 'identified_only',
  capture_pageview: true,
  capture_pageleave: true,
  session_recording: {
    maskAllInputs: false,
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
